// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12974":"skin-copy","50169":"aria-labels"}[chunkId] || chunkId) + "-" + {"12974":"2a875ff7c422f8497413","18718":"a3caa19e0e417ecaff8e","27031":"0a239c091611ebe6422d","38834":"05399b2c22d241cc3d26","50169":"d3b8f340652682e737a1","89831":"30cfe3ff1aa88556a7c7"}[chunkId] + ".min.js";
};